/**
 * @file PDFのダウンロードリンクのリストに必要な情報をまとめている
 */

import JsonUtil from '../../util/JsonUtil'
import { TargetType } from '../PageList'

export interface PdfLink {
  linkTitle: string
  linkUrl: string
  size: string
}

export interface PageLink {
  linkTitle: string
  linkUrl: string
}

export interface ConfigSet {
  documentId: number
  configId: number
}

export interface ImageSet {
  documentId: number
  imagePath: string
  imageAlt: string
  description: string
}

export class Conditions {
  public title = ''
  public subTitle = ''
  public description = ''
  public source: TargetType = ''
  public max = 0
  public filterTypes: string[] = []
  public key = 0
  public linkTitle = ''
  public linkUrl = ''
  public anchor = ''
  public columnTitle = ''
  public pageLinks: PageLink[] = []
  public pdfLinks: PdfLink[] = []
  public configList: ConfigSet[] = []
  public imageList: ImageSet[] = []
  public filter = false

  /**
   * オブジェクトの作成
   *
   * @param data JSONレコード
   * @returns JSONから作成したオブジェクト
   */
  public static crate(data: Record<string, unknown>): Conditions {
    const obj: Conditions = JsonUtil.jsonToObject<Conditions>(Conditions, data)
    return obj
  }
}

export interface Anchor {
  id: string
  label: string
  optional: boolean
}

export class AnchorConditions {
  hasMore = false
  more: Anchor | null = null
  anchors: Anchor[] = []
  links: Anchor[] = []

  /**
   * オブジェクトの作成
   *
   * @param data JSONレコード
   * @returns JSONから作成したオブジェクト
   */
  public static crate(data: Record<string, unknown>): AnchorConditions {
    const obj: AnchorConditions = JsonUtil.jsonToObject<AnchorConditions>(
      AnchorConditions,
      data
    )
    return obj
  }
}
